import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { Utility } from 'src/app/shared/utils/utility.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { AccountSettingsService } from '../account-setting.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-account-profile-change',
  templateUrl: './account-profile-change.component.html',
  styleUrls: ['./account-profile-change.component.scss'],
})
export class AccountProfileChangeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() profileImageSrc?: any; //close event of parent component
  @Output() profileImageSrcChange = new EventEmitter<any>();
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() SuccessMessage!: string;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() SuccessMessageChange = new EventEmitter<string>();
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  errorMessage: string = '';
  formGroup!: FormGroup;
  siteId!: string;
  file!: {
    data: any;
    state: string;
    inProgress: boolean;
    progress: number;
    canRetry: boolean;
    canCancel: boolean;
  };
  profilePictureKey!: string;
  validImage: boolean = false;
  subscription: Subscription | undefined;
  groupName!: string;
  groupTypeId!: string;

  constructor(
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    public commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private stateManagementService: StateManagementService,
    private userManagementService: UserManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.subscription = this.route.params.subscribe((params) => {
      this.groupName = Utility.decodeFromBase64(params['groupTypeName']);
      this.groupTypeId = Utility.decodeFromBase64(params['userGroupId']);
    });
    this.formGroup = new FormGroup({
      photo: new FormControl(
        null,
        MFValidators.compose([MFValidators.required, MFValidators.whitespace])
      ),
    });
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
  }

  addPhotoClickHandler() {
    const fileUpload: any = document.getElementById(
      'accountProfileUpload'
    ) as HTMLInputElement;
    fileUpload.onchange = () => {
      const file = fileUpload?.files[0];
      this.formGroup.patchValue({
        photo: file?.name,
      });
      if (!Utility.checkValidImageExtension(file?.name || 'file.invalid')) {
        this.formGroup.controls.photo.setErrors({ invalidImage: true });
        this.validImage = false;
        return;
      }

      this.file = {
        data: file,
        state: 'in',
        inProgress: false,
        progress: 0,
        canRetry: false,
        canCancel: true,
      };
      this.startUploadProcess(file);
    };
    fileUpload.click();
  }

  startUploadProcess(file: File) {
    if (Utility.checkValidImageSize(file?.size, 25)) {
      this.formGroup?.controls?.photo?.setErrors({ invalidImageSize: true });
      this.validImage = false;
      return;
    }
    //showing image after uploading
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.profileImageSrc = reader.result;
    };
    this.validImage = true;
  }
  uploadImageHandler(): void {
    if (this.validImage && this.file?.data) {
      const file = this.file?.data;
      const fileType = file?.type;
      this.accountSettingService.getSiteBucketPresignedURL(fileType).subscribe({
        next: async (res: any) => {
          await this.uploadFile(res, file);
          const currentUrl = this.router.url;

          if (currentUrl.includes(CONSTANTS.USER_DASHBOARD)) {
            const encodedGroupName = Utility.encodeToBase64(this.groupName);
            const encodedGroupTypeId = Utility.encodeToBase64(this.groupTypeId);
            this.router.navigate([
              `${CONSTANTS.USER_DASHBOARD}${encodedGroupName}/${encodedGroupTypeId}`,
            ]);
          } else if (currentUrl.includes(CONSTANTS.DASHBOARD_URL)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                if (window.__dev__) this.router.navigateByUrl(currentUrl);
              });
          } else if (currentUrl.includes(CONSTANTS.USERS)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                if (window.__dev__) this.router.navigateByUrl(currentUrl);
              });
          } else if (currentUrl.includes(CONSTANTS.SITE_MANAGEMENT)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                if (window.__dev__) this.router.navigateByUrl(currentUrl);
              });
          }
        },
        error: (err: Error) => {
          this.notificationService.showError(err?.message);
        },
      });
    }
  }

  async uploadFile(preSignedURLData: any, file: File) {
    return new Promise((resolve, reject) => {
      let { fields } = preSignedURLData;
      this.profilePictureKey = fields['key'];
      var fd = new FormData();
      let fieldsKeys = Object.keys(fields);
      for (const field of fieldsKeys) {
        fd.append(field, fields[field]);
      }
      fd.append('file', file);
      // this call post image to the S3 bucket with presignedUrl
      this.accountSettingService
        .uploadFile(preSignedURLData.url, fd)
        .subscribe({
          next: (response: any) => {
            this.updateUserProfile().then((res) => resolve(res));
          },
          error: (error: Error) => {
            this.updateUserProfile().then((res) => resolve(res));
          },
        });
    });
  }

  updateUserProfile() {
    return new Promise((resolve, reject) => {
      let profilePictureName = this.file?.data?.name;
      let profilePictureKey = this.profilePictureKey;
      this.accountSettingService
        .updateProfileImage(
          profilePictureName,
          profilePictureKey,
          this.profileImageSrc
        )
        .subscribe({
          next: (res: any) => {
            this.stateManagementService.updateUsersList([]);
            this.userManagementService.setTriggerRerender(true);
            this.notificationService.showSuccess(
              this.commonService.stringInterPolation(
                this.translate.instant('SUCCESSFULLY_UPDATED'),
                this.translate.instant('USER_PROFILE')
              )
            );
            this.profileImageSrcChange.emit(this.profileImageSrc);
            this.navigateBack();
            resolve(true);
          },
          error: (error: Error) => {
            this.notificationService.showError(error?.message);
            reject(false);
          },
        });
    });
  }
}
